import React from "react";
import { Col, Row } from "antd";
import "./TextHeader.scss";

const TextHeaderComponent = () => {
  return (
    <Row align={"middle"} className="TextHeaderComponent row">
      <Col xs={0} lg={1}>
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.7833 1.46893C25.8936 1.57282 25.9549 1.73213 25.9549 1.89144V14.0819C25.9549 14.2135 25.912 14.3451 25.8384 14.4421C25.7956 14.5044 25.7343 14.5529 25.673 14.5875C25.5014 14.6776 25.2931 14.6499 25.1522 14.5044L22.8667 12.3157L14.16 23.9105C13.9823 24.146 13.6759 24.1737 13.4676 23.9728C13.2593 23.7719 13.2348 23.4256 13.4125 23.1901L22.4317 11.1659C22.6094 10.9304 22.9158 10.9027 23.1241 11.1036L24.9745 12.8767V2.54252L15.9553 4.23256L17.8057 6.00572C18.014 6.20659 18.0385 6.55291 17.8608 6.7884L9.16018 18.3901L11.4456 20.5789C11.5927 20.7174 11.654 20.939 11.5988 21.1468C11.5498 21.3546 11.3966 21.5139 11.2067 21.5486L0.569831 23.5364C0.428905 23.5641 0.281852 23.5157 0.171562 23.4118C0.0612721 23.3079 0 23.1555 0 22.9962V10.8057C0 10.591 0.11029 10.3901 0.281852 10.3001C0.453414 10.21 0.661739 10.2378 0.802665 10.3832L3.08811 12.572L11.7949 0.970226C11.9726 0.734728 12.2789 0.707022 12.4873 0.907888C12.6956 1.10875 12.7201 1.45507 12.5424 1.69057L3.52315 13.7148C3.34546 13.9503 3.0391 13.978 2.83077 13.7771L0.980354 12.004V22.3382L10.0057 20.6551L8.14919 18.875C7.94086 18.6741 7.91636 18.3278 8.09405 18.0923L16.8008 6.49057L14.5154 4.30183C14.3683 4.1633 14.307 3.94165 14.3622 3.73386C14.4112 3.52607 14.5644 3.36676 14.7543 3.33213L25.385 1.34425C25.526 1.31655 25.673 1.36503 25.7833 1.46893Z"
            fill="#3D5176"
          />
        </svg>
      </Col>
      <Col xs={24} lg={18} className="header-text" > <div>Simulador de transferencia de vehículos</div></Col>
      {/* <div> Ejemplos del proceso</div> */}
    </Row>
  );
};

export default TextHeaderComponent;
